import { useTranslation } from 'react-i18next';
import { useAuth } from '@/modules/auth/AuthContext';
import { useVenueContext } from './VenueContext';
import { DashboardPreview } from './dashboardPreview/DashboardPreview';

/**
 * Workspace index for `/loc/:venueId`. A landing inside one Venue; the real
 * venue-bound features hang off the sidebar. The `venue-id` testid is the seam the
 * routing tests assert the `:venueId` param resolves through `VenueContext`.
 *
 * The body currently renders a mocked {@link DashboardPreview} (daily-summary cards + expected
 * attendance chart); it is replaced when the dashboard is wired to real data.
 */
export function VenueHome() {
  const { t } = useTranslation('common');
  const { venues } = useAuth();
  const { venueId } = useVenueContext();
  const venueName = venues.find((venue) => venue.id === venueId)?.name ?? venueId;

  return (
    <section className="grid gap-4 p-6">
      <div className="flex items-baseline justify-between gap-2">
        <h1 className="text-2xl font-semibold">{venueName}</h1>
        <span className="text-muted-foreground text-xs tracking-wide uppercase">
          {t('workspace.dashboard.preview')}
        </span>
      </div>
      <DashboardPreview />
      <p data-testid="venue-id" className="sr-only">
        {venueId}
      </p>
    </section>
  );
}
